import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule} from '@angular/router';

import { PaginationModule } from 'ngx-bootstrap';
import { Pipe, PipeTransform, Injectable } from '@angular/core';
//import { DatePipe } from '@angular/common'
import { PopoverModule } from 'ngx-popover';
import { ContextMenuModule } from 'ngx-contextmenu';
import { TextMaskModule } from 'angular2-text-mask';
//import { NgxMaskModule } from 'ngx-mask';
//import { SortJsonData } from '../app/Pipes/SortingPipe';
//import { FilterJsonData } from '../app/Pipes/FilterPipe';
//import { DefaultTS } from '../app/SharedComponents/Default';
//import { TopMessageDiv } from '../app/SharedComponents/TopMessageDiv';
//import { RoutingState } from '../app/SharedComponents/RoutingState';
//import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { ChartsModule } from 'ng2-charts'

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
//import { HomeComponent } from './home/home.component';
//import { CounterComponent } from './counter/counter.component';
//import { FetchDataComponent } from './fetch-data/fetch-data.component';
//import { MonthView } from './Calendar/MonthView/MonthView';
//import { TestCalendar } from './Calendar/TestCalendar/TestCalendar';
//import { WeekView } from './Calendar/WeekView/WeekView';
//import { ShowModal } from './SharedComponents/ShowModal';
//import { DayView } from './Calendar/DayView/DayView';
//import { YearView } from './Calendar/YearView/YearView';
import { Login } from './Login/Login';
//import { ForgotPassword } from './ForgotPassword/ForgotPassword';
//import { Category } from './AMTCategory/Category';

//import { PFIResourceType } from './Admin/ResourcesManagement/PFIResourceType/PFIResourceType';
//import { PFIResourceScript } from './Admin/ResourcesManagement/PFIResource/PFIResourceScript';
//import { BookingLog } from './BookingManagement/BookingLog/BookingLog';
//import { VehicleBooking } from './BookingManagement/VehicleBooking/VehicleBooking';
//import { Messaging } from './Communication/Messaging';
//import { PFIResourceAttributeScript } from './Admin/PFIResourceAttribute/PFIResourceAttributeScript';
//import { FileUploaderCustom } from '../app/SharedComponents/FileUploader';
//import { ContentLibrary } from './ContentLibrary/ContentLibrary';
//import { PFIEventScript } from './Admin/EventsBooking/PFIEvent/PFIEventScript';
//import { PFIEventTypeScript } from './Admin/EventsBooking/PFIEventType/PFIEventTypeScript';
//import { PFIResourceBookingScript } from './Admin/EventsBooking/PFIResourceBooking/PFIResourceBookingScript';
//import { PFIEventRequirementScript } from './Admin/EventsBooking/PFIEventRequirement/PFIEventRequirementScript';
//import { PFIEventReqChoiceScript } from './Admin/EventsBooking/PFIEventReqChoice/PFIEventReqChoiceScript';
//import { Assessment } from './Assessment/Assessment';
//import { Timer } from '../app/SharedComponents/Timer';

//import { AMTQuestionnaireScript } from './Admin/Assessment/AMTQuestionnaire/AMTQuestionnaireScript';
//import { AMTQuestionScript } from './Admin/Assessment/AMTQuestion/AMTQuestionScript';
//import { AMTQuestionOptionsScript } from './Admin/Assessment/AMTQuestionOptions/AMTQuestionOptionsScript';
//import { AMTToDoListScript } from './Admin/EventsRegisteration/ToDoList/AMTToDoListScript';
//import { EventDashboard } from './EventDashboard/EventDashboard';
//import { AMTRunningOrderScript } from './Admin/EventsRegisteration/AMTRunningOrder/AMTRunningOrderScript';
//import { AMTIBBStaffTargetsScript } from './Admin/AMTIBBStaffTargets/AMTIBBStaffTargetsScript';
//import { AMTRunningOrderResponsibleScript } from './Admin/EventsRegisteration/AMTRunningOrderResponsible/AMTRunningOrderResponsibleScript';
//import { AMTRunningOrderExternalScript } from './Admin/EventsRegisteration/AMTRunningOrderExternal/AMTRunningOrderExternalScript';
//import { PFIContentLibraryCategoryScript } from './Admin/ContentLibrary/PFIContentLibraryCategory/PFIContentLibraryCategoryScript';
//import { JLRDashboard } from './JLRDashboard/JLRDashboard';
//import { AMTCompetencyLevelScript } from './Admin/PDP/AMTCompetencyLevel/AMTCompetencyLevelScript';
//import { AMTCompetencyScript } from './Admin/PDP/AMTCompetency/AMTCompetencyScript';
//import { AMTCompetencyTypeScript } from './Admin/PDP/AMTCompetencyType/AMTCompetencyTypeScript';
//import { AMTCourseScript } from './Admin/PDP/AMTCourse/AMTCourseScript';
//import { AMTCourseCategoryScript } from './Admin/PDP/AMTCourseCategory/AMTCourseCategoryScript';
//import { AMTCourseTypeScript } from './Admin/PDP/AMTCourseType/AMTCourseTypeScript';
//import { AMTCourseRequirementTypeScript } from './Admin/PDP/AMTCourseRequirementType/AMTCourseRequirementTypeScript';
//import { AMTCourseRequirementScript } from './Admin/PDP/AMTCourseRequirement/AMTCourseRequirementScript';
//import { AMTJobRoleScript } from './Admin/PDP/AMTJobRole/AMTJobRoleScript';
//import { AMTRoleCourseScript } from './Admin/PDP/AMTRoleCourse/AMTRoleCourseScript';
//import { AMTStaffScript } from './Admin/PDP/AMTStaff/AMTStaffScript';
//import { LowerCaseUrlSerializer } from './SharedComponents/URLSerializer';
//import { AMTStaffCourseScript } from './Admin/PDP/AMTStaffCourse/AMTStaffCourseScript';
//import { AMTStaffRoleScript } from './Admin/PDP/AMTStaffRole/AMTStaffRoleScript';
//import { AMTStaffRoleGroupScript } from './Admin/PDP/AMTStaffRoleGroup/AMTStaffRoleGroupScript';
//import { PDPDashboard } from './PDPDashboard/PDPDashboard';
//import { PDPProgressReport } from './PDPProgressReport/PDPProgressReport';
//import { PFIBulletinScript } from './Admin/PFI/PFIBulletin/PFIBulletinScript';
//import { JLRDashboardDetails } from './JLRDashboard/JLRDashboardDetails';
//import { EventDashboardDetails } from './EventDashboard/EventDashboardDetails';
//import { AMTEventRotationScript } from './Admin/EventsBooking/AMTEventRotation/AMTEventRotationScript';
//import { CoursesdashboardComponent } from './coursesdashboard/coursesdashboard.component';
//import { Budget } from '../app/Finance/Budget/Budget';
//import { PurchaseOrders } from '../app/Finance/PurchaseOrders/PurchaseOrders';
//import { Transactions } from '../app/Finance/Transactions/Transactions';

//import { BudgetCategoryScript } from './Admin/Finance/BudgetCategory/BudgetCategoryScript';
//import { BudgetCategoryTypeScript } from './Admin/Finance/BudgetCategoryType/BudgetCategoryTypeScript';
//import { CurrencyScript } from './Admin/Finance/Currency/CurrencyScript';
//import { TestGraphsComponent } from './test-graphs/test-graphs.component';
//import { ReportsComponent } from './reports/reports';
//import { FileViewer } from './FileViewer/FileViewer';
//import { ManageGroupsScript } from './Admin/ManageGroups/ManageGroupsScript';
//import { ManagementComponent } from './ManagementSkillsAssessments/ManagementSkillsAssessments';
//import { AMTQuestionnaireSectionScript } from './Admin/ManagementSkillsAssessments/AMTQuestionnaireSection/AMTQuestionnaireSectionScript';
//import { AMTSectionScript } from './Admin/ManagementSkillsAssessments/AMTSection/AMTSectionScript';
//import { HRAssessmentScript } from './Admin/ManagementSkillsAssessments/HRAssessment/HRAssessmentScript';
//import { HRAssessmentTypeScript } from './Admin/ManagementSkillsAssessments/HRAssessmentType/HRAssessmentTypeScript';
//import { HRGroupScript } from './Admin/ManagementSkillsAssessments/HRGroup/HRGroupScript';
//import { AMTCourseRequiredScript } from './Admin/AMTCourseRequired/AMTCourseRequiredScript';
//import { ManageBlockDaysComponent } from './ManageBlockDays/ManageBlockDays';
//import { CereportComponent } from './CEReport/CEReport';
//import { RecaptchaModule } from 'ng-recaptcha';
//import { ResetpasswordComponent } from './resetpassword/resetpassword';
//import { AMTUsheringScript } from './Admin/AMTUshering/AMTUsheringScript'
//import { AMTUsheringDelegateScript } from './Admin/AMTUsheringDelegate/AMTUsheringDelegateScript';
//import { AMTCEReportCriteriaScript } from './Admin/AMTCEReportCriteria/AMTCEReportCriteriaScript';
//import { DelegateProgressReport } from '../app/DelegateProgressReport/DelegateProgressReport';
//import { SixweeklyannouncementComponent } from './reports/sixweeklyannouncement/sixweeklyannouncement';
//import { ThreeweeklyannouncementComponent } from './reports/threeweeklyannouncement/threeweeklyannouncement';
//import { LJProgressionReport } from '../app/reports/LJ Progression Report/LJProgressionReport';
//import { TechnicalLevelAssessmentScript } from './Admin/AMTTechnicalLevelAssessment/TechnicalLevelAssessmentScript';
//import { IBBDashboard } from './reports/IBBCompetencyReport/IBBDashboard/IBBDashboard';
//import { IBBUsersByLevel } from './reports/IBBCompetencyReport/IBBUsersByLevel/IBBUsersByLevel';
//import { DealersLookUpScript } from './Admin/DealersLookUp/DealersLookUpScript';
//import { ELearningDataScript } from './Admin/ELearningData/ELearningDataScript';
//import { MandatoryELearningComponent } from './reports/MandatoryELearning/MandatoryELearning';
//import { IBBLaunchTraining } from './reports/IBBLaunchTraining/IBBLaunchTraining';
//import { AMTEqualCourseScript } from './Admin/EqualCourse/AMTEqualCourseScript';
//import { Retentionreport } from './reports/retentionreport/retentionreport';
//import { AMTRelRoleGroupAndCourseScript } from './Admin/AMTRelRoleGroupAndCourse/AMTRelRoleGroupAndCourseScript';
//import { AMTRelRoleGroupAndJobRoleScript } from './Admin/AMTRelRoleGroupAndJobRole/AMTRelRoleGroupAndJobRoleScript';
//import { AMTRoleGroupScript } from './Admin/AMTRoleGroup/AMTRoleGroupScript'
//import { AMTStaffLevelsScript } from './Admin/AMTStaffLevels/AMTStaffLevelsScript'
//import { AMTStaffLevelTargetScript } from './Admin/AMTStaffLevelTarget/AMTStaffLevelTargetScript'
import { PersistenceModule } from 'angular-persistence';
//import { TechAssessmentScript } from './Admin/TechAssessment/TechAssessmentScript';
//import { TechAssessmentResponseScript } from './Admin/TechAssessmentResponse/TechAssessmentResponseScript';
//import { AMTQuestionnaireCoursesScript } from './Admin/AMTQuestionnaireCourses/AMTQuestionnaireCoursesScript';
//import { AttachmentScript } from './Admin/Attachments/AttachmentScript';
//import { AdminsComponent } from './Admins/Admins';
import { SharedDataModule } from './SharedData.module';
import { AppRoutingModule } from './app-routing.module';
@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    //HomeComponent,
    //CounterComponent,
    //FetchDataComponent,
    //SortJsonData,
    //FilterJsonData,
    //DefaultTS,
    //TopMessageDiv,
    //Timer,
    //FileUploaderCustom,
    //ShowModal,
    //MonthView,
    //TestCalendar,
    //WeekView,
    //DayView,
    //YearView,
    Login,
    //ForgotPassword,
    //Category,
    //PFIResourceType,
    //ContentLibrary,
    //BookingLog,
    //VehicleBooking,
    //Messaging,
    //PFIResourceScript,
    //PFIEventScript,
    //PFIEventTypeScript,
    //PFIResourceBookingScript,
    //PFIEventRequirementScript,
    //PFIEventReqChoiceScript,
    //Assessment,
    //AMTQuestionnaireScript,
    //AMTQuestionScript,
    //AMTQuestionOptionsScript,
    //EventDashboard,
    //AMTToDoListScript,
    //AMTRunningOrderScript,
    //AMTRunningOrderResponsibleScript,
    //AMTRunningOrderExternalScript,
    //PFIResourceAttributeScript,
    //PFIContentLibraryCategoryScript,
    //JLRDashboard,
    //AMTStaffScript,
    //AMTCompetencyLevelScript,
    //AMTCompetencyScript,
    //AMTCompetencyTypeScript,
    //AMTCourseCategoryScript,
    //AMTCourseTypeScript,
    //AMTJobRoleScript,
    //AMTRoleCourseScript,
    //AMTStaffCourseScript,
    //AMTStaffRoleScript,
    //AMTCourseScript,
    //AMTStaffRoleGroupScript,
    //PDPDashboard,
    //AMTStaffRoleGroupScript,
    //AMTStaffRoleGroupScript,
    //PDPProgressReport,
    //PFIBulletinScript,
    //JLRDashboardDetails,
    //EventDashboardDetails,
    //AMTEventRotationScript,
    //CoursesdashboardComponent,
    //Budget,
    //PurchaseOrders,
    //Transactions,
    //BudgetCategoryTypeScript,
    //BudgetCategoryScript,
    //CurrencyScript,
    //AMTCourseRequirementTypeScript,
    //AMTCourseRequirementScript,
    //TestGraphsComponent,
    //ReportsComponent,
    //FileViewer,
    //ManageGroupsScript,
    //ManagementComponent,
    //AMTQuestionnaireSectionScript,
    //AMTSectionScript,
    //HRAssessmentScript,
    //HRAssessmentTypeScript,
    //AMTCourseRequiredScript,
    //HRGroupScript,
    //ManageBlockDaysComponent,
    //CereportComponent,
    //AMTUsheringScript,
    //AMTUsheringDelegateScript,
    //ResetpasswordComponent,
    //AMTCEReportCriteriaScript,
    //DelegateProgressReport,
    //SixweeklyannouncementComponent,
    //ThreeweeklyannouncementComponent,
    //TechnicalLevelAssessmentScript,
    //IBBDashboard,
    //IBBUsersByLevel,
    //DealersLookUpScript,
    //ELearningDataScript,
    //MandatoryELearningComponent,
    //AMTEqualCourseScript,
    //IBBLaunchTraining,
    //Retentionreport,
    //AMTIBBStaffTargetsScript,
    //AMTRelRoleGroupAndCourseScript,
    //AMTRelRoleGroupAndJobRoleScript,
    //AMTRoleGroupScript,
    //AMTStaffLevelsScript,
    //AMTStaffLevelTargetScript,
    //TechAssessmentScript,
    //TechAssessmentResponseScript,
    //AMTQuestionnaireCoursesScript,
    //AdminsComponent,
    //LJProgressionReport,
    //AttachmentScript
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
   // RecaptchaModule.forRoot(),
    PaginationModule.forRoot(),
    ContextMenuModule.forRoot(),
    //NgxMaskModule.forRoot(),
    SharedDataModule.forRoot(),
    TextMaskModule,
    PopoverModule,
    HttpClientModule,
    //Ng2GoogleChartsModule,
    ChartsModule,
    FormsModule,
    PersistenceModule,
    AppRoutingModule,
    RouterModule.forRoot([
      { path: '', component: Login, pathMatch: 'full' },
      //{ path: 'counter', component: CounterComponent },
      //{ path: 'fetch-data', component: FetchDataComponent },
      //{ path: 'monthview', component: MonthView },
      //{ path: 'calendar', component: TestCalendar },
      //{ path: 'login', component: Login },
      //{ path: 'category', component: Category },
      //{ path: 'resourcedashboard', component: PFIResourceType },
      //{ path: 'contentlibrary', component: ContentLibrary },
      //{ path: 'pfiresource', component: PFIResourceScript },
      //{ path: 'forgotpassword', component: ForgotPassword },
      //{ path: 'bookinglog', component: BookingLog },
      //{ path: 'vehiclebooking', component: VehicleBooking },
      //{ path: 'messaging', component: Messaging },
      //{ path: 'pfiresourceattribute', component: PFIResourceAttributeScript },
      //{ path: 'events', component: PFIEventScript },
      //{ path: 'pfieventtype', component: PFIEventTypeScript },
      //{ path: 'pfiresourcebooking', component: PFIResourceBookingScript },
      //{ path: 'pfieventrequirement', component: PFIEventRequirementScript },
      //{ path: 'pfieventreqchoice', component: PFIEventReqChoiceScript },
      //{ path: 'assessment', component: Assessment },
      //{ path: 'amtquestionnaire', component: AMTQuestionnaireScript },
      //{ path: 'amtquestion', component: AMTQuestionScript },
      //{ path: 'eventdashboard', component: EventDashboard },
      //{ path: 'amttodoList', component: AMTToDoListScript },
      //{ path: 'amtrunningorder', component: AMTRunningOrderScript },
      //{ path: 'pficontentlibrarycategory', component: PFIContentLibraryCategoryScript },
      //{ path: 'dashboard', component: JLRDashboard },
      //{ path: 'amtcompetency', component: AMTCompetencyScript },
      //{ path: 'amtcompetencylevel', component: AMTCompetencyLevelScript },
      //{ path: 'amtcompetencytype', component: AMTCompetencyTypeScript },
      //{ path: 'amtcourse', component: AMTCourseScript },
      //{ path: 'amtcoursecategory', component: AMTCourseCategoryScript },
      //{ path: 'amtcoursetype', component: AMTCourseTypeScript },
      //{ path: 'amtjobrole', component: AMTJobRoleScript },
      //{ path: 'amtrolecourse', component: AMTRoleCourseScript },
      //{ path: 'amtstaff', component: AMTStaffScript },
      //{ path: 'amtstaffcourse', component: AMTStaffCourseScript },
      //{ path: 'amtstaffrole', component: AMTStaffRoleScript },
      //{ path: 'amtstaffrolegroup', component: AMTStaffRoleGroupScript },
      //{ path: 'pdpdashboard', component: PDPDashboard },
      //{ path: 'pdpprogressreport', component: PDPProgressReport },
      //{ path: 'pfibulletin', component: PFIBulletinScript },
      //{ path: 'dashboarddetails', component: JLRDashboardDetails },
      //{ path: 'eventdashboarddetails', component: EventDashboardDetails },
      //{ path: 'eventrotation', component: AMTEventRotationScript },
      //{ path: 'courses', component: CoursesdashboardComponent },
      //{ path: 'budget', component: Budget },
      //{ path: 'purchaseorders', component: PurchaseOrders },
      //{ path: 'transactions', component: Transactions },
      //{ path: 'budgetcategorytype', component: BudgetCategoryTypeScript },
      //{ path: 'budgetcategory', component: BudgetCategoryScript },
      //{ path: 'currency', component: CurrencyScript },
      //{ path: 'courserequirementtype', component: AMTCourseRequirementTypeScript },
      //{ path: 'courserequirement', component: AMTCourseRequirementScript },
      //{ path: 'testgraphs', component: TestGraphsComponent },
      //{ path: 'reports', component: ReportsComponent },
      //{ path: 'managementskillsassessments', component: ManagementComponent },
      //{ path: 'fileviewer', component: FileViewer },
      //{ path: 'managegroups', component: ManageGroupsScript },
      //{ path: 'amtquestionnairesection', component: AMTQuestionnaireSectionScript },
      //{ path: 'amtsection', component: AMTSectionScript },
      //{ path: 'hrassessment', component: HRAssessmentScript },
      //{ path: 'hrassessmenttype', component: HRAssessmentTypeScript },
      //{ path: 'hrgroup', component: HRGroupScript },
      //{ path: 'courserequired', component: AMTCourseRequiredScript },
      //{ path: 'manageblockdays', component: ManageBlockDaysComponent },
      //{ path: 'cereport', component: CereportComponent },
      //{ path: 'resetpassword', component: ResetpasswordComponent },
      //{ path: 'ushering', component: AMTUsheringScript },
      //{ path: 'usheringdelegate', component: AMTUsheringDelegateScript },
      //{ path: 'delegateprogressreport', component: DelegateProgressReport },
      //{ path: 'threeweeklyannouncement', component: ThreeweeklyannouncementComponent },
      //{ path: 'sixweeklyannouncement', component: SixweeklyannouncementComponent },
      //{ path: 'technicalassessments', component: TechnicalLevelAssessmentScript },
      //{ path: 'ibbdashboard', component: IBBDashboard },
      //{ path: 'ibbusersbylevel', component: IBBUsersByLevel },
      //{ path: 'dealerslookup', component: DealersLookUpScript }, 
      //{ path: 'elearningdata', component: ELearningDataScript },
      //{ path: 'mandatoryelearning', component: MandatoryELearningComponent },
      //{ path: 'equalcourse', component: AMTEqualCourseScript },
      //{ path: 'ibblaunchtraining', component: IBBLaunchTraining },
      //{ path: 'retentionreport', component: Retentionreport },
      //{ path: 'ibbstafftargets', component: AMTIBBStaffTargetsScript },
      //{ path: 'rolegroup', component: AMTRoleGroupScript },
      //{ path: 'rolegroupandcourse', component: AMTRelRoleGroupAndCourseScript },  
      //{ path: 'rolegroupandjobrole', component: AMTRelRoleGroupAndJobRoleScript },
      //{ path: 'stafflevels', component: AMTStaffLevelsScript },
      //{ path: 'staffleveltarget', component: AMTStaffLevelTargetScript },
      //{ path: 'techassessment', component: TechAssessmentScript },
      //{ path: 'techassessmentresponse', component: TechAssessmentResponseScript },
      //{ path: 'questionnairecourses', component: AMTQuestionnaireCoursesScript },
      //{ path: 'adminmanage', component: AdminsComponent },
      //{ path: 'ljprogression', component: LJProgressionReport },
      //{ path: 'attachments', component: AttachmentScript },
      { path: '**', component: Login }

    ])
  ],
  //providers: [FileUploaderCustom, SortJsonData, FilterJsonData, DefaultTS, Messaging, RoutingState, DatePipe,
  //  {
  //    provide: UrlSerializer,
  //    useClass: LowerCaseUrlSerializer
  //  }],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor() {
    console.log('AppModule loaded.');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts